<!-- src/components/MessageList.vue -->
<template>
  <div class="messages">
    <TransitionGroup name="message">
      <div v-for="message in messages" :key="message.id" :class="['message', message.type]"
        @click="removeMessage(message.id)">
        {{ message.text }}
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useMessagesStore } from '@/stores/messages'

const store = useMessagesStore()
const { messages } = storeToRefs(store)
const removeMessage = store.remove
</script>

<style scoped>
.messages {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 400px;
}

.message {
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  color: white;
  animation: slideIn 0.3s ease-out;
}

.message.success {
  background-color: #4caf50;
}

.message.error {
  background-color: #f44336;
}

.message.warning {
  background-color: #ff9800;
}

.message.info {
  background-color: #2196f3;
}

.message-enter-active,
.message-leave-active {
  transition: all 0.3s ease;
}

.message-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.message-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
